import scroll from 'utilities/scroll';
import { throttle } from 'utilities/helperFunctions';

export const throttledGeoAddressScroll = throttle((idField = 'typeOfRoad') => {
    const addressAutocompleteElement = document.getElementById(idField);
    addressAutocompleteElement && scroll.transition(addressAutocompleteElement, 'percentage', 0.935);
}, 100);
